import { gql } from "@apollo/client";

export const CREATE_DATA_EXPORT_V2 = gql`
  mutation CreateDataExportV2($data: DataExportV2Input!) {
    createDataExportV2(data: $data) {
      id
    }
  }
`;

export const VALIDATE_EXPORT_TARGET_V2 = gql`
  mutation ValidateExportTargetV2(
    $data: DataExportV2ValidateDestinationInput!
  ) {
    validateExportTargetV2(data: $data) {
      status
      message
    }
  }
`;
